import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import liff from "@line/liff";
import { LoadingOverlay } from "@/apps/@components";
import { LiffModule } from "@/apps/modules";
import { shareCampaigns } from "./campaigns";

export default function ShareToFriendsPage() {
	const [searchParams] = useSearchParams();

	useEffect(() => {
		(async () => {
			try {
				const liffId = process.env.REACT_APP_LIFF_ID;
				if (!liffId) {
					console.error("Missing REACT_APP_LIFF_ID environment variable.");
					return;
				}
				await liff.init({ liffId });

				if (!liff.isLoggedIn()) {
					liff.login({ redirectUri: window.location.href });
					return;
				}

				const shareCode = searchParams.get("share_code");
				const buildFlexMessages = shareCode
					? shareCampaigns[shareCode]
					: undefined;

				if (!buildFlexMessages) {
					console.error(`未知或缺少 share_code: ${shareCode}`);
					LiffModule.closeLiffWindow();
					return;
				}

				const { displayName } = await liff.getProfile();
				await LiffModule.sendFlexMessages(
					buildFlexMessages(displayName),
					true,
				);
			} catch (error) {
				console.error("ShareToFriendsPage 初始化失敗:", error);
				LiffModule.closeLiffWindow();
			}
		})();
	}, []);

	return <LoadingOverlay visible={true} />;
}
